/**
 * Formats a canonical address object (User.buyerAddress or same shape) for display.
 * Includes street, city, region, country, and postal/zip when present.
 */
export function formatFullAddress(addr) {
    if (!addr || typeof addr !== 'object') return '';
    const parts = [
        addr.unitNumber ? `${addr.address}, ${addr.unitNumber}` : addr.address,
        addr.city,
        addr.state?.name,
        addr.country?.name || addr.country,
        addr.postalCode || addr.zipCode,
    ].filter((p) => p != null && String(p).trim() !== '');
    return parts.join(', ');
}

/** Public label: city, province, country. The street is only shown once an order is paid. */
export function formatCityRegion(addr) {
    if (!addr || typeof addr !== 'object') return '';
    return [addr.city, addr.state?.name || addr.state, addr.country?.name || addr.country]
        .filter((p) => p && typeof p === 'string' && p.trim() !== '')
        .join(', ');
}

/** Short label: city, country — for compact headers when full line is too long */
export function formatCityCountry(addr) {
    if (!addr || typeof addr !== 'object') return '';
    const city = addr.city || '';
    const country = addr.country?.name || addr.country || '';
    return [city, country].filter(Boolean).join(', ');
}
